import React from 'react';
import classnames from 'classnames';

import { TextButtonRegularSmall as TextButton } from '@xingternal/malt-button';
import styles from './TextButton.css';

const CustomTextButton = ({
  children,
  className,
  isPetrol = false,
  ...rest
}) => {
  const classNames = classnames(
    {
      [styles.petrol]: isPetrol,
    },
    className
  );

  return (
    <TextButton className={classNames} {...rest}>
      {children}
    </TextButton>
  );
};

export default CustomTextButton;
